import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { shopgold } from "@/lib/platforms-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/platformy/shopgold";

export const Route = createFileRoute("/platformy/shopgold")({
  head: () =>
    buildSeoMeta({
      title: "Wdrożenia ShopGold — integracje, hurtownie, dropshipping | SyncTech",
      description:
        "Wdrożenia i migracje ShopGold dla sklepów e-commerce. Integracje z hurtowniami, Baselinker, Allegro, ERP. Optymalizacja SEO i prędkości. Bezpłatna konsultacja.",
      path: PATH,
    }),
  component: () => <PlatformPage data={shopgold} path={PATH} breadcrumbCategory="Platformy" />,
});
